import Box from '@mui/material/Box';
import { Outlet } from '@tanstack/react-router';
import { lazy, Suspense, type ComponentType } from 'react';
import { Spinner } from '@repo/ui';

/** `React.lazy` for a named export: `lazyPage(() => import('../pages/x/XPage'), 'XPage')`. */
export function lazyPage<M extends Record<K, ComponentType>, K extends keyof M & string>(
  load: () => Promise<M>,
  name: K,
): M[K] {
  return lazy(() => load().then((m) => ({ default: m[name] }))) as unknown as M[K];
}

/** Shown in the content area while a page chunk loads (the shell stays in place). */
export function PageFallback() {
  return (
    <Box
      aria-busy
      sx={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary.main',
      }}
    >
      <Spinner />
    </Box>
  );
}

export function SuspenseOutlet() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Outlet />
    </Suspense>
  );
}
